<template>
  <main-layout selectedMenu="explore" id="subject-edit-page">
    <div class="setting-layout">
      <div class="left">
        <p class="communset">{{$t('global.频道设置')}}</p>
        <ul>
          <li @click="changeIndex(1)" :class="{activeli:activeIndex == 1}">
            <span class="iconbgimg0"></span>
            {{$t('global.基本信息')}}
          </li>
          <li @click="changeIndex(2)" :class="{activeli:activeIndex == 2}" v-show="topicId != ''">
            <span class="iconbgimg2"></span>
            {{$t('global.设置 banner')}}
          </li>
          <li @click="changeIndex(3)" :class="{activeli:activeIndex == 3}" v-show="topicId != ''">
            <span class="iconbgimg3"></span>
            {{$t('global.视频管理')}}
          </li>
          <li @click="changeIndex(4)" :class="{activeli:activeIndex == 4}" v-show="topicId != ''">
            <span class="iconbgimg4"></span>
            {{$t('global.活动管理')}}
          </li>
          <li @click="changeIndex(5)" :class="{activeli:activeIndex == 5}" v-show="topicId != ''">
            <span class="iconbgimg5"></span>
            {{$t('global.创作者')}}
          </li>
          <li @click="changeIndex(6)" :class="{activeli:activeIndex == 6}" v-show="topicId != ''">
            <span class="iconbgimg6"></span>
            {{$t('global.相关频道')}}
          </li>
        </ul>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "subjectEdit",
  metaInfo() {
    return {
      title: this.$t("global.频道设置") + " | MANA"
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      activeIndex: 1,
      isEdit: true,
      topicId: ""
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    init() {
      this.isEdit = this.$route.name.includes("Edit");
      if (this.isEdit) {
        this.topicId = this.$route.params.id;
      }
      switch (this.$route.name) {
        case "subjectEditStep1":
          this.activeIndex = 1;
          break;
        case "subjectEditStep2":
          this.activeIndex = 2;
          break;
        case "subjectEditStep3":
          this.activeIndex = 3;
          break;
        case "subjectEditStep4":
          this.activeIndex = 4;
          break;
        case "subjectEditStep5":
          this.activeIndex = 5;
          break;
        case "subjectEditStep6":
          this.activeIndex = 6;
          break;
      }
    },
    changeIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 1:
          this.$router.push("step1");
          break;
        case 2:
          this.$router.push("step2");
          break;
        case 3:
          this.$router.push("step3");
          break;
        case 4:
          this.$router.push("step4");
          break;
        case 5:
          this.$router.push("step5");
          break;
        case 6:
          this.$router.push("step6");
          break;
        default:
          break;
      }
    },

    Submit() {
      var $this = this;
      let param = this.$pureData(this.stepForm);
      this.$refs["stepForm"].validate(valid => {
        if (valid) {
          this.$http
            .post("/api/u/topic/updateAppearance", param)
            .then(function(response) {
              if (response) {
                $this.$message({
                  message: $this.$t("global.保存成功"),
                  type: "success",
                  duration: 2000
                });
                if ($this.isEdit) {
                  $this.$router.push(
                    "/SubjectEditStep3?id=" + $this.stepForm.id
                  );
                } else {
                  $this.$router.push("/subjectdetail/" + $this.stepForm.id);
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    ReturnBack() {
      this.$router.push("/subjectdetail/" + this.stepForm.id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.setting-layout {
  position: relative;
  display: flex;
  flex-direction: row;
  width: 1160px;
  min-height: calc(100vh - 250px);
  margin: 35px auto 0;
  overflow: hidden;

  .left {
    height: 100%;
    font-size: 16px;
    color: #333;
    overflow: hidden;
    border: 1px solid rgba(238, 238, 238, 1);
    box-sizing: border-box;
    background-color: #fafafa;
    width: 166px;

    .communset {
      height: 51px;
      font-size: 16px;
      font-weight: bold;
      padding-left: 36px;
      line-height: 52px;
      color: rgba(51, 51, 51, 1);
      border-bottom: 1px solid #edecf1;
      background-color: #fff;
      box-sizing: border-box;
    }

    ul {
      li {
        width: 166px;
        height: 43px;
        font-size: 16px;
        line-height: 43px;
        cursor: pointer;
        color: rgba(153, 153, 153, 1);
        padding-left: 20px;
        font-weight: 500;
        box-sizing: border-box;

        &> span {
          display: inline-block;
          float: left;
          width: 20px;
          height: 20px;
          margin: 11px 10px 0 0;
        }

        &.activeli {
          color: #fff;
          background: #00adef;

          .iconbgimg0 {
            background: url('/static/home/images/iconseting00.png') no-repeat;
          }

          .iconbgimg1 {
            background: url('/static/home/images/iconseting11.png') no-repeat;
          }

          .iconbgimg2 {
            background: url('/static/home/images/iconseting22.png') no-repeat;
          }

          .iconbgimg3 {
            background: url('/static/home/images/iconseting33.png') no-repeat;
          }

          .iconbgimg4 {
            background: url('/static/home/images/iconseting44.png') no-repeat;
          }

          .iconbgimg5 {
            background: url('/static/home/images/iconseting55.png') no-repeat;
          }

          .iconbgimg6 {
            background: url('/static/home/images/iconseting66.png') no-repeat;
          }
        }

        .iconbgimg0 {
          background: url('/static/home/images/iconseting0.png') no-repeat;
        }

        .iconbgimg1 {
          background: url('/static/home/images/iconseting1.png') no-repeat;
        }

        .iconbgimg2 {
          background: url('/static/home/images/iconseting2.png') no-repeat;
        }

        .iconbgimg3 {
          background: url('/static/home/images/iconseting3.png') no-repeat;
        }

        .iconbgimg4 {
          background: url('/static/home/images/iconseting4.png') no-repeat;
        }

        .iconbgimg5 {
          background: url('/static/home/images/iconseting5.png') no-repeat;
        }

        .iconbgimg6 {
          background: url('/static/home/images/iconseting6.png') no-repeat;
        }
      }
    }
  }

  .right {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/SubjectEdit.vue